import React from 'react';

import PayAtHotel from '../../stories/Icons/PayAtHotel';
import ReserverNowPayLater from '../../stories/Icons/ReserveNowPayLater';
import FreeCancelIcon from '../../stories/Icons/FreeCancelIcon';
import FreeBreakfast from '../../stories/Icons/Amenities/FreeBreakfast';
import RoundedCheckbox from '../../stories/Icons/RoundedCheckbox';

import HappyFreeCancelIcon from '@stencil/icons/src/HappyFreeCancelIcon/HappyFreeCancelIcon';
import HappyBookNowPayLaterIcon from '@stencil/icons/src/HappyBookNowPayLaterIcon/HappyBookNowPayLaterIcon';
import HappyFreeBreakFastIcon from '@stencil/icons/src/HappyFreeBreakFastIcon/HappyFreeBreakFastIcon';
import HappyPayAtHotelNewIcon from '@stencil/icons/src/HappyPayAtHotelNewIcon/HappyPayAtHotelNewIcon';

const FiltersIconSelector = ({
  name = '',
  styleProps,
}: {
  name: string;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
}) => {
  if (!name) return <RoundedCheckbox {...styleProps} />;

  switch (name) {
    case 'Free Cancellation Available':
      return <HappyFreeCancelIcon {...styleProps} />;
    case 'Free Breakfast Included':
      return <HappyFreeBreakFastIcon {...styleProps} />;
    case 'Pay At Hotel Available':
      return <HappyPayAtHotelNewIcon {...styleProps} />;
    case 'Book Now, Pay Later Available':
      return <HappyBookNowPayLaterIcon {...styleProps} />;

    default:
      return <RoundedCheckbox {...styleProps} />;
  }
};

export default FiltersIconSelector;
